import React from "react";
import BaseInput from "./BaseInput";

interface EmailInputProps {
  email: string;
  setEmail: (value: string) => void;
  useFloatingLabel?: boolean;
}

export default function EmailInput({
  email,
  setEmail,
  useFloatingLabel = true
}: EmailInputProps) {
  return (
    <BaseInput
      value={email}
      onChange={setEmail}
      label="Email"
      type="email"
      useFloatingLabel={useFloatingLabel}
    />
  );
} 